import React from 'react'
import clsx from 'clsx'

export function Container({
  as: Component = 'div',
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'> & { as?: React.ElementType }) {
  return (
    <Component
      className={clsx('container mx-auto px-4 md:px-8', className)}
      {...props}
    />
  )
}
